module.exports = __webpack_public_path__ + "static/media/emoji1.d30e9ad3.svg";